/* eslint-disable prefer-template */
import Config from 'es6/core/config';
import ItemQuizBase from 'es6/controllers/apps/quizzes/item-quiz-base';
import Logger from 'es6/services/logger';
import { ResultTypes } from 'es6/models/quiz-result';
import StudyScreen from 'es6/components/apps/screens/study';

/**
 * @this Study
 */
function handleRemove() {
  this._screenManager.fireEvent('skip_item_initiated');
}

export class Study extends ItemQuizBase {
  constructor(...args) {
    super(...args);
    this._setQuizType('Study');
  }

  show() {
    const { itemPackage } = this;
    const screenProperties = {
      isNew: !itemPackage.memory,
      itemPackage,
      onNext: this.finishQuiz.bind(this),
      onRemove: handleRemove.bind(this),
      showTranscription: Config.showTranscriptions,
    };

    Logger.info('Quiz', 'Showing Study quiz for ' + itemPackage.item.cue.text, this);
    this.result.setResult(ResultTypes.SEEN);
    this._screenManager.renderComponent(StudyScreen, screenProperties);
    this.result.beginPhase('study');
  }
}

export default Study;
